import React, {
  useEffect, useState, useReducer,
} from 'react';

import { API } from 'aws-amplify';

const appointmentContext = React.createContext ();

const useAppointments = () => {
  const [ initialized, setInitialized ] = useState(false);
  const [ appointments, setAppointments]  = useState ([])
  const [ selected, setSelected ] = useState(null);

  const select = (from) => {
    setSelected (from);
  }

  const reload = async () => {
    const res = await API.get ('appointments', '/free');
    setAppointments(res);
  }

  useEffect (() => {
    if (!initialized)
    (async() => {
      const res = await API.get ('appointments', '/free');
      setInitialized(true);
      setAppointments(res);
    })()
  }) 

  return {
    isPending: !initialized,
    data: appointments,
    selected,
    select,
    reload
  }
}

const AppointmentProvider = ({children}) => {
  const { isPending, data, select, selected, reload } = useAppointments ();
  return <appointmentContext.Provider value={{ isPending, data, select, selected, reload }}>
    {children}
  </appointmentContext.Provider>
}

export { AppointmentProvider, appointmentContext }